import { useContext } from 'react'
import { LocationDataContext } from 'src/store/locations/Store'
import { MapDataContext } from 'src/store/map/Store'

const useLocation = () => {
  const { map } = useContext(MapDataContext)
  const { locations } = useContext(LocationDataContext)
  const location = locations[map.variables.location_id]
  return { location }
}

export default useLocation
